module.exports = __webpack_public_path__ + "static/media/KD.22e84d59.svg";